<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs default-active-key="config">
        <a-tab-pane key="config" tab="推荐配置">
      <a-form layout="vertical">
        <a-row :gutter="48">
          <a-col :md="12" :sm="24">
            <a-form-item label="每批推荐总条数">
              <a-input-number v-model="form.totalCount" :min="5" :max="50" style="width: 200px" placeholder="默认10" />
              <span class="form-item-extra">每批拉取的帖子总数，默认10条</span>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item label="广告位数量">
              <a-input-number v-model="form.adCount" :min="0" :max="10" style="width: 200px" placeholder="默认2" />
              <span class="form-item-extra">每批中的广告推帖数量，默认2条</span>
            </a-form-item>
          </a-col>
        </a-row>

        <a-divider>分类比例配置</a-divider>
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" v-for="item in categoryList" :key="item.value">
            <a-form-item :label="item.label + '（%）'">
              <a-input-number v-model="item.percent" :min="0" :max="100" style="width: 150px" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-alert v-if="totalPercent !== 100" type="warning" :message="'各分类比例之和为 ' + totalPercent + '%，请确保总和为 100%'" show-icon style="margin-bottom: 16px" />

        <a-divider />
        <a-form-item>
          <a-button type="primary" @click="handleSave" :loading="saveLoading" :disabled="totalPercent !== 100">
            保存配置
          </a-button>
          <a-button style="margin-left: 12px" @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getRecommendConfig, saveRecommendConfig } from '@/api/community/recommend/recommendConfig'

export default {
  name: 'RecommendConfig',
  data () {
    return {
      form: {
        id: null,
        totalCount: 10,
        adCount: 2
      },
      categoryList: [
        { label: '商品帖', value: 10, percent: 40 },
        { label: '漫展', value: 20, percent: 30 },
        { label: 'COSER', value: 30, percent: 10 },
        { label: '游戏', value: 40, percent: 5 },
        { label: '动漫', value: 50, percent: 5 },
        { label: '普通', value: 99, percent: 10 }
      ],
      saveLoading: false
    }
  },
  computed: {
    totalPercent () {
      return this.categoryList.reduce((sum, item) => sum + (item.percent || 0), 0)
    }
  },
  created () {
    this.fetchConfig()
  },
  methods: {
    fetchConfig () {
      getRecommendConfig().then(res => {
        if (res.data) {
          this.form.id = res.data.id
          this.form.totalCount = res.data.totalCount || 10
          this.form.adCount = res.data.adCount || 2
          if (res.data.categoryRatio) {
            try {
              const ratio = JSON.parse(res.data.categoryRatio)
              this.categoryList.forEach(item => {
                if (ratio[item.value] !== undefined) {
                  item.percent = ratio[item.value]
                }
              })
            } catch (e) {
              console.warn('解析分类比例失败', e)
            }
          }
        }
      }).catch(() => {})
    },
    handleSave () {
      const ratioObj = {}
      this.categoryList.forEach(item => {
        ratioObj[item.value] = item.percent || 0
      })
      const params = {
        id: this.form.id,
        totalCount: this.form.totalCount,
        adCount: this.form.adCount,
        categoryRatio: JSON.stringify(ratioObj),
        isEnabled: true
      }
      this.saveLoading = true
      saveRecommendConfig(params).then(() => {
        this.$message.success('保存成功')
        this.fetchConfig()
      }).finally(() => {
        this.saveLoading = false
      })
    },
    handleReset () {
      this.form.id = null
      this.form.totalCount = 10
      this.form.adCount = 2
      this.categoryList = [
        { label: '商品帖', value: 10, percent: 40 },
        { label: '漫展', value: 20, percent: 30 },
        { label: 'COSER', value: 30, percent: 10 },
        { label: '游戏', value: 40, percent: 5 },
        { label: '动漫', value: 50, percent: 5 },
        { label: '普通', value: 99, percent: 10 }
      ]
      this.fetchConfig()
    }
  }
}
</script>

<style scoped>
.form-item-extra {
  display: block;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  margin-top: 4px;
}
</style>
